import { render, staticRenderFns } from "./list-return-requested-form.vue?vue&type=template&id=bb0d80b2&"
import script from "./list-return-requested-form.vue?vue&type=script&lang=js&"
export * from "./list-return-requested-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports